/**
 * @file   公共底部
 * @create macaiqi 2021/07/27
 * @update
 */
import React, { useRef, useEffect,useState } from 'react';
// import { Link } from 'react-router-dom'
import { useLocation } from 'react-router';
import cls from 'classnames'
import $ from 'jquery';
import { debounce } from '../../../../utils';
import './index.scss';
import topBtn from '@/assets/images/desktop/common/top_btn.png';
import codeBtn from '@/assets/images/desktop/common/code_btn.png';
import topBtn1 from '@/assets/images/desktop/common/top_btn_active.png';
import codeBtn1 from '@/assets/images/desktop/common/code_btn_active.png';
import codeImg from '@/assets/images/desktop/common/code_img.png';


// 公共底部
const Footer = () => {
  // const year = new Date().getFullYear();
  const { pathname } = useLocation()
  const [active1,setActive1] = useState(false)
  const [active2,setActive2] = useState(false)
  const hasnav = pathname?.includes('/Subject')
  const toTopHandleClick = () => {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  };
  const toTop = useRef();
  const scroll = () => {
    const top = document.body.scrollTop || document.documentElement.scrollTop;
    if (top > 600) {
      $('.totop').addClass('show');
      $('.codeBtn').addClass('show');
    } else {
      $('.totop').removeClass('show');
      $('.codeBtn').removeClass('show');
    }
  };
  const debounceScroll = debounce(scroll, 430);
  useEffect(() => {
    window.addEventListener('scroll', debounceScroll);
    return () => {
      window.removeEventListener('scroll', debounceScroll);
    };
  }, [debounceScroll]);

  return (
    <footer className={cls("common-footer", { hasnav })}>
      <div className="totop" ref={toTop} onClick={toTopHandleClick} onMouseEnter={() => {setActive1(true);}} onMouseLeave={() => {setActive1(false);}}>
        {active1 && <img src={topBtn1} />}
        {!active1 && <img src={topBtn} />}
      </div>
      <div className="codeBtn" onMouseEnter={() => {setActive2(true);}} onMouseLeave={() => {setActive2(false);}}>
        {active2 && <img src={codeBtn1} />}
        {!active2 && <img src={codeBtn} />}
        <div className="ewmbox">
          <div className='ewmitem'><img src={codeImg}/></div>
        </div>
      </div>
      <div className="allcenter">
        {/* {
          pathname?.includes('/Subject') && <ul>
            <li><Link to='/Refenrences'>参考文献</Link></li>
          </ul>
        } */}
        <p>版权所有©安徽博物院</p>
        <p>技术支持：武汉数文慧图科技有限公司</p>
      </div>
    </footer >
  );
};

export default Footer;
